import React, { useState, useEffect } from "react";
import SelectMember from "./selectMember";
import useQuery from "../../shared/utils/queryParams";
import Loader from "../../shared/components/loader";
import ErrorMessage from "../../shared/components/errorMessage";
import getMockFamilyData from "./mockFamilyData";

function SelectMemberContainer() {
  const [members, setMembers] = useState([]);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessageText, setShowErrorMessageText] = useState(undefined);

  const query = useQuery();
  const isSynthetic = query.get("synthetic");

  // synthetic users are for cigna testing
  const getSyntheticUsers = () => {
    const family = JSON.parse(query.get("family"));

    if (family.length) {
      const transformedFamily = family.map((member) => ({
        enterpriseId: member.eid,
        firstName: member.firstname,
        lastName: member.lastname,
      }));
      setMembers(transformedFamily);
    }
  };

  const getMembers = async () => {
    try {
      // const response = getMockFamilyData();
      const response = await fetch(process.env.REACT_APP_FAMILY_PROFILE_URL);
      const responseJson = await response.json();
      if (responseJson.metadata.outcome.status === 200) {
        setMembers(transformMembers(responseJson.data));
      } else {
        const errorMessage = getErrorMessage(
          responseJson.metadata.outcome.code
        );
        setShowErrorMessageText(errorMessage);
        setShowErrorMessage(true);
      }
    } catch (e) {
      setShowErrorMessageText(getErrorMessage(11));
      setShowErrorMessage(true);
    }
  };

  const transformMembers = (members) =>
    members
      .map((member) => {
        return member.role.toLowerCase() === "repcustomer"
          ? { ...member, role: "subscriber" }
          : { ...member, role: member.role.toLowerCase() };
      })
      .filter((m) => m.role !== "personalrep")
      .sort((m) => (m.role === "subscriber" ? -1 : 1));

  const getErrorMessage = (code) => {
    const map = {
      101001: "Validation failed. ",
      101004:
        "We’re sorry, but due to your unique plan design, you cannot download your Protected Health Information (PHI) to 3rd party apps at this time.",
      102000: "Error processing this request. Please try later.",
      999999:
        "Operation failed or did not complete successfully. Please try later.",
    };
    const errorText = map[code];
    return errorText
      ? errorText
      : "Oops… myCigna is currently unavailable. We are working to correct the issue. Please try again later.";
  };

  useEffect(() => {
    isSynthetic ? getSyntheticUsers() : getMembers();
  }, []);

  return showErrorMessage ? (
    <ErrorMessage title={"Error"} message={errorMessageText}></ErrorMessage>
  ) : members.length ? (
    <SelectMember members={members}></SelectMember>
  ) : (
    <Loader></Loader>
  );
}

export default SelectMemberContainer;
